exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-share{margin:20px 0;display:-webkit-box;display:-ms-flexbox;display:flex}.social-share .sprite{width:25px;height:25px}.social-share .sprite.reddit-icon{fill:#ec5428}.social-share .sprite.email-icon{fill:grey}.social-share a{margin-right:12px;display:block;-webkit-transition:-webkit-transform .2s ease-in-out;transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out}.social-share a:hover{-webkit-transform:scale(1.15);transform:scale(1.15)}", ""]);

// exports
